export default "__VITE_ASSET__BnHFi$me__"